import { Client, Environment } from 'vivaa-api';

// re-export the namespaces from vivaa-api, for access to types
export * from 'vivaa-api';

const hostname = document.location.hostname;
const env: Environment =
  hostname === 'localhost' || hostname === '127.0.0.1' || hostname.endsWith('.localhost')
    ? Environment.Weblocal
    : Environment.Webprod;
export const client = new Client(env);
